import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_BusApp from "./Content_BusApp";
import Footer from '../../components/Footer/Footer';

class BusApp extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_BusApp />
                <Footer />
            </div>

        )
    }
}

export default BusApp;